import {
  faFacebookF,
  faInstagram,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';
import { REDEEM_IMAGE_TYPES } from './constants';
import { KLARNA_ENABLED } from './features';

const ENV = process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod';

export const PRODUCTION_SITE = 'https://www.5pm.co.uk';

// GLOBAL
export const GLOBAL_LINKS = {
  dev:
    process.env.NEXT_PUBLIC_BASE_ROOT_URL ||
    'https://whitelabel09.dev5pm.co.uk',
  nxt:
    process.env.NEXT_PUBLIC_BASE_ROOT_URL ||
    'https://whitelabel01.nxt5pm.co.uk',
  prod: 'https://www.5pm.co.uk',
};
export const GLOBAL_LINKS_SECURE = {
  dev: 'https://secure05.dev5pm.co.uk',
  nxt: 'https://secure01.nxt5pm.co.uk',
  prod: 'https://www.5pm.co.uk',
};
export const LINK_HOME = `${GLOBAL_LINKS[ENV]}`;
export const LINK_PREFERENCE_CENTRE = `${GLOBAL_LINKS[ENV]}/email/preferences`;

// APP STORES
export const LINK_APPLE_APP_STORE =
  'https://wowcher.onelink.me/j47e/IOSwebsitelozenge';
export const LINK_GOOGLE_PLAY_STORE =
  'https://wowcher.onelink.me/j47e/ANDwebsitelozenge';

// Checkout and Second Checkout Links
export const LINK_CHECKOUT = `/checkout`;
export const LINK_CHECKOUT_RELATIVE = `/checkout`;
export const LINK_CHECKOUT_BUTTON = `/checkout`;
export const LINK_SECOND_CHECKOUT = `${GLOBAL_LINKS[ENV]}/order-addon`;

// Search Page
export const LINK_SEARCH_PAGE = `${GLOBAL_LINKS[ENV]}/search`;

export const LINK_WISHLIST = `/wishlist`;

// Map View
export const MAP_VIEW_LINK = '/map-view';
// Login Register URLS
export const LINK_LOGIN = '/login';
export const LOGIN_URL = 'login';
export const REGISTER_URL = 'register';

export const LINK_NOT_LOGGED_USER = `${GLOBAL_LINKS[ENV]}/${LOGIN_URL}`; // Dont need to be the same as login

export const LINK_FORGOT_PASSWORD = `/forgot-password`;
export const RESET_PASSWORD = '/request-password-reset';

// FOOTER LEGAL LINKS
export const FOOTER_LEGAL_LINKS = [
  {
    href: 'https://www.5pm.co.uk/page/e-commerceterms#contract',
    text: 'Billing Terms & Conditions',
  },
  {
    href: 'https://help.wowcher.co.uk/knowledgebase/s/article/Refunds',
    text: 'Refunds & Returns',
  },
  { href: 'https://www.5pm.co.uk/page/termsofuse', text: 'Terms of use' },
  {
    href: 'https://www.5pm.co.uk/page/privacypolicy',
    text: 'Privacy & Cookies Policy',
  },
  {
    href: 'https://www.5pm.co.uk/page/e-commerceterms',
    text: 'E-Commerce Terms',
  },
  {
    href: 'https://www.5pm.co.uk/page/internetsafety',
    text: 'Internet Safety',
  },
  {
    href: 'https://www.5pm.co.uk/page/uk-modern-slavery-act-transparency-statement',
    text: 'UK modern slavery act',
  },
  {
    href: 'https://www.5pm.co.uk/page/takedown',
    text: 'Takedown Policy',
  },
  KLARNA_ENABLED && {
    href: 'https://www.5pm.co.uk/page/klarna-faqs',
    text: 'Klarna FAQs',
  },
];

// Login Menu
export const LOGIN_MENU = [
  {
    href: `/myaccount/vouchers`,
    text: 'My Vouchers',
  },
  {
    href: `/myaccount/profile`,
    text: 'My Details',
  },
];

// RAF enabled menu (for wowcher/wowcherie only)
export const RAF_ENABLED_LOGIN_MENU = [
  ...LOGIN_MENU,
  {
    href: `/myaccount/refer-a-friend`,
    text: 'Refer a Friend',
  },
];

export const REGISTER_MENU = [
  {
    href: `${GLOBAL_LINKS[ENV]}/${LOGIN_URL}`,
    text: 'Login',
  },
  {
    href: `${GLOBAL_LINKS[ENV]}/${REGISTER_URL}`,
    text: 'Sign Up',
  },
];

export const MOBILE_MENU_MORE_LINKS = [
  { href: 'https://help.wowcher.co.uk', text: 'Need Help' },
  // {
  //   href: `https://business.wowcher.co.uk/`,
  //   text: 'Work With Us',
  // },
  // { href: 'https://marketplace.5pm.co.uk', text: 'Create a deal' },
  {
    href: `${GLOBAL_LINKS[ENV]}/page/aboutus`,
    text: 'About Us',
  },
  {
    href: `https://help.wowcher.co.uk/knowledgebase/s/`,
    text: 'FAQs',
  },
  {
    href: `${GLOBAL_LINKS[ENV]}/page/privacypolicy`,
    text: 'Privacy & Cookie Policy',
  },
  {
    href: `${GLOBAL_LINKS[ENV]}/page/termsofuse`,
    text: 'Terms of use',
  },
  {
    href: `${GLOBAL_LINKS[ENV]}/page/e-commerceterms`,
    text: 'E-commerce terms',
  },
  {
    href: `${GLOBAL_LINKS[ENV]}/page/internetsafety`,
    text: 'Internet Safety',
  },
  // {
  //   href: `${GLOBAL_LINKS[ENV]}/giftcard/redeem`,
  //   text: 'Redeem Gift Card',
  // },
];

// TODO: update this with correct 5pm value
export const LINKS_GLOBAL_CWV = {
  dev: '',
  nxt: 'https://rum.corewebvitals.io/cwv/65ae7a2e4f27fb498cf8a247.js',
  prod: 'https://rum.corewebvitals.io/cwv/65ae7a2e4f27fb498cf8a247.js',
};

export const LINKS_GLOBAL_DTM = {
  dev: '//assets.adobedtm.com/db068b679b47/6a3293276648/launch-c08ee5ef4467-development.min.js',
  nxt: '//assets.adobedtm.com/db068b679b47/6a3293276648/launch-45e6c253f8aa-staging.min.js',
  prod: '//assets.adobedtm.com/db068b679b47/6a3293276648/launch-3fe5e3b3ffce.min.js',
};
export const LINKS_GLOBAL_ONETRUST =
  'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js';
export const LINKS_GLOBAL_ONETRUST_AUTOBLOCK = `https://cdn-ukwest.onetrust.com/consent/${process.env.NEXT_PUBLIC_ONETRUST_KEY}/OtAutoBlock.js`;

// MINI MENU
export const MINI_MENU_LINKS = {
  BECOME_MERCHANT: `/page/businessfaq`,
  CREDIT: `/myaccount/credit`,
  MY_ACCOUNT_DETAILS: `/myaccount/profile`,
  MY_GIFT: `/mygift`,
  MY_VOUCHERS: `/myaccount/vouchers`,
  NEED_HELP: `https://help.wowcher.co.uk/`,
  RAF: `/myaccount/refer-a-friend`,
  REDEEM_GIFT_CARD: `/giftcard/redeem`,
  REWARDS: `/myaccount/rewards`,
  WALLET: `/myaccount/wallet`,
};

// More Popover
export const MORE_POPOVER_LINKS = [];

export const LINKS_GLOBAL = {
  dev: process.env.NEXT_PUBLIC_BASE_ROOT_URL || 'https://www09.dev5pm.co.uk',
  nxt: process.env.NEXT_PUBLIC_BASE_ROOT_URL || 'https://www01.nxt5pm.co.uk',
  prod: 'https://www.5pm.co.uk',
};

export const MARKETING_CLAIMS_DEF_LINK =
  'https://www.5pm.co.uk/page/marketingdefinitions.html';

export const LINKS_GLOBAL_PAYPAL = {
  dev: 'ASOxT2nj3kc5OkR2f4O3Mg5Bt88XBGIYIdHqPg1sUORhl-cLpGyLvgW6OocfgOi7qNmUpJzdJEzTsfFr',
  nxt: 'ASOxT2nj3kc5OkR2f4O3Mg5Bt88XBGIYIdHqPg1sUORhl-cLpGyLvgW6OocfgOi7qNmUpJzdJEzTsfFr',
  prod: 'AR951hC7nvA6w4AR3uK4aC9APN7PU0fBUQiBfDqt0h8CyEryokAB9yHjeaDT',
};

export const ADMIN_FEE_TERMS = 'https://www.5pm.co.uk/page/admin-fee';
export const DISCOUNT_CODE_LINK = 'https://www.5pm.co.uk/discountcodes';

export const REDEEM_IMAGES = {
  [REDEEM_IMAGE_TYPES.calendar]:
    'https://resources.wowcher.co.uk/assets/img/5pm_redeem_travel_calendar.svg',
  [REDEEM_IMAGE_TYPES.callToBook]:
    'https://resources.wowcher.co.uk/assets/img/5pm_redeem_travel_merchant.svg',
  [REDEEM_IMAGE_TYPES.chooseYourFlight]:
    'https://resources.wowcher.co.uk/assets/img/5pm_redeem_int_travel.svg',
  [REDEEM_IMAGE_TYPES.mysteryTravel]:
    'https://resources.wowcher.co.uk/assets/img/5pm_redeem_mystery.svg',
  [REDEEM_IMAGE_TYPES.standard]:
    'https://resources.wowcher.co.uk/assets/img/5pm_redeem.svg',
  [REDEEM_IMAGE_TYPES.standardTravel]:
    'https://resources.wowcher.co.uk/assets/img/5pm_redeem_travel_standard.svg',
};

// Gift Finder
export const LINK_GIFT_FINDER = (location) => `/deal/${location}/gift-finder`;

// my accounts
export const CLUB_WOWCHER_LINK = '/page/aboutClubWowcher';
export const LINK_MYACCOUNT_PASSWORD = `/myaccount/password`;

export const NEED_HELP_LINK = `https://help.wowcher.co.uk/`;

export const LINK_MY_VOUCHERS_DELETE = '/myaccount/delete';
export const LINK_MY_VOUCHERS = `/myaccount/vouchers`;

export const LINKS_GLOBAL_AWIN = {
  dev: 'https://www.dwin1.com/108580.js',
  nxt: 'https://www.dwin1.com/108580.js',
  prod: 'https://www.dwin1.com/108580.js',
};

export const WALLET_CREDIT_INFO = '/page/wallet-credit-more-info';
export const WALLET_TERMS_OF_USE = '/page/wallettermsofuse';
export const ECOMMERCE_TERMS = 'https://www.5pm.co.uk/page/e-commerceterms';

// Checkout
export const LINK_ECOMMERCE_TERMS = {
  href: 'https://www.5pm.co.uk/page/e-commerceterms',
  text: 'E-Commerce Terms',
};

// APP BANNER
export const APP_BANNER_DEEPLINK_APPLE = 'https://wowcher.app.link/mIzxxPXGI4';

export const APP_BANNER_DEEPLINK_ANDROID =
  'https://wowcher.app.link/mIzxxPXGI4';

// update this with correct 5pm value

// VIP T&C
export const LINK_VIP_TERMS =
  'https://www.5pm.co.uk/page/vip-terms-and-conditions';

// PMV T&C
export const LINK_PMV_TERMS =
  'https://www.5pm.co.uk/page/e-commerceterms#protect-my-voucher';
export const LINK_CONTACT_US = `https://api.whatsapp.com/send?phone=447917171746`;

// VVE
export const LINK_VVE_TERMS =
  'https://www.5pm.co.uk/page/e-commerceterms#voucher-validity-extensions';

// Voucher Accordion Testing Links
// TODO: update this with correct 5pm value
export const BRANCH_LINKS_PROD = 'https://wowcher.app.link/buzi0hczjqb';
// TODO: update this with correct 5pm value
export const BRANCH_LINKS_DEV = 'https://wowcher.test-app.link/G9OeOIoYhqb';
// Buy Again
export const LINK_BUY_AGAIN = `/buy-again`;

export const DOWNLOAD_APP_LINKS_LINKS = {
  linkAppleAppStore: '',
  linkGooglePlayStore: '',
};

export const LINK_CAREERS = LINK_HOME;

export const SOCIAL_MEDIA_SHARE_LINKS = [
  {
    ariaLabel: 'Facebook Page',
    backgroundColor: '#0052a3',
    href: 'https://www.facebook.com/koobleit',
    icon: faFacebookF,
  },
  {
    ariaLabel: 'Twitter Page',
    backgroundColor: '#4099ff',
    href: 'https://x.com/5pm',
    icon: faTwitter,
  },
  {
    ariaLabel: 'Instagram Page',
    backgroundColor: '#125688',
    href: 'https://www.instagram.com/kooble_scotland/',
    icon: faInstagram,
  },
];

// GIFT CARD
export const GIFT_CARD_TERMS = '/page/giftcardterms';

// Paypal
export const PAYPAL_CREDIT_LINK =
  'https://www.paypal.com/uk/webapps/mpp/paypal-virtual-credit/faq';

export const FOOTER_DEALS_LINKS = [
  {
    href: `${GLOBAL_LINKS[ENV]}/deals/shop`,
    text: 'Shopping',
  },
  /* {
    href: `${GLOBAL_LINKS[ENV]}/guides/holiday-deals`,
    text: 'Holiday Deals',
  },
  {
    href: `${GLOBAL_LINKS[ENV]}/guides/hub`,
    text: 'Guides',
  },
  {
    href: `${GLOBAL_LINKS[ENV]}/giftcard/redeem`,
    text: 'Redeem Gift Card',
  },
  {
    href: `${GLOBAL_LINKS[ENV]}/near-me/hub`,
    text: 'Near Me',
  },
  {
    href: `${GLOBAL_LINKS[ENV]}/guides/black-friday-deals`,
    text: 'Black Friday Deals',
  },
  {
    href: `${GLOBAL_LINKS[ENV]}/discountcodes`,
    text: 'Discount Codes',
  }, */
  {
    href: `${GLOBAL_LINKS[ENV]}/editorial-team`,
    text: 'Meet Our Writers',
  },
];

export const FOOTER_ABOUT_US = 'About Us';
export const FOOTER_MERCHANT_FAQ = 'Merchant FAQs';
export const FOOTER_AFFILIATE_FAQ = 'Affiliate FAQs';
export const FOOTER_PRESS = 'Press FAQs';
export const FOOTER_COMPANY_LINKS = [
  {
    href: `${GLOBAL_LINKS[ENV]}/page/aboutus`,
    text: FOOTER_ABOUT_US,
  },
  {
    href: `https://business.wowcher.co.uk/`,
    text: FOOTER_MERCHANT_FAQ,
  },
  {
    href: `${GLOBAL_LINKS[ENV]}/guides/5pm-affiliates`,
    text: FOOTER_AFFILIATE_FAQ,
  },
  {
    href: `${GLOBAL_LINKS[ENV]}/guides/press-resources`,
    text: FOOTER_PRESS,
  },
  // {
  //   href:
  //     'https://blog.wowcher.co.uk/?_ga=2.267451022.107186891.1597051109-1566888493.1580121875',
  //   text: 'Blog',
  // },
];

export const FOOTER_COMPLAINTS = 'Complaints';
export const FOOTER_RECALLS = 'Product Recalls';
export const FOOTER_REFUNDS_RETURNS = 'Refunds and Returns';
export const NEED_HELP = 'Need Help';
export const FOOTER_CONTACT_US = 'Contact Us';
export const FOOTER_CUSTOMER_SERVICE_LINKS = [
  {
    href: `https://help.wowcher.co.uk`,
    text: NEED_HELP,
  },
  {
    href: `https://help.wowcher.co.uk/knowledgebase/s/article/Refunds`,
    text: FOOTER_REFUNDS_RETURNS,
  },
  {
    href: `https://help.wowcher.co.uk/articles/faqs/i-would-like-to-make-a-complaint/649c271a42417c2dcb614222`,
    text: FOOTER_COMPLAINTS,
  },
  {
    href: `${GLOBAL_LINKS[ENV]}/page/productrecalls`,
    text: FOOTER_RECALLS,
  },
];

export const LINK_LOGGED_USER = GLOBAL_LINKS[ENV];
export const ANGULAR_HOME_URL = `${GLOBAL_LINKS[ENV]}`;

// TODO: update this with correct wowcher ie value
// todo : n---- // loyalityBanner: inside config.js. Change the usuage every where
export const LOYALTY_BANNER_CONFIG = {
  id: 'wfe16e2da1004ab8c4eeef6fb60c4ac08',
  key: '6665313665326461313030346162386334656565663666623630633461633038',
};

// TODO: update this with correct wowcher ie value --- //loyalityBannerInPage : inside config.js
export const LOYALTY_IN_PAGE_BANNER_CONFIG = {
  id: 'w438e7aa4d0fa8635a8b9a091b9e72125',
  key: '3433386537616134643066613836333561386239613039316239653732313235',
};

export const GIFTS_LINK = ''; // only used in wowcher
